import React from "react";
import { validations } from "validations/FormValidations";
import { Checklist_Type_OPTIONS } from "api/modules/common.option";
import { Column } from "Components/Common/CommonTableIndexWise";
import { formatDate } from "common/service/CommonService";

export const icfMasterColumns = (
  options: any[] = [],
  options2: any[] = [],
  categoryOptions: any[] = []
): Column[] => [
    {
      key: "question",
      label: "Checkpoints",
      tooltip: true,
      maxLength: 100,
    },
    {
      key: "checklisttypetext",
      label: "Checklists",
    },
    {
      key: "isrequired",
      label: "Is Required",
      textCenter: true,
      render: (value: any) => (
        <div className="text-center">
          <span className={`badge ${value ? "bg-success" : "bg-danger"}`}>
            {value ? "Yes" : "No"}
          </span>
        </div>
      ),
    },
  ];

export const checklistTypeColumns = (
  onTypeClick: (row: any) => void,
  categoryMap?: (row: any) => any,
  categoryOptions: any[] = []
): Column[] => [
  {
    key: "label",
    label: "Checklists",
    type: "link",
    onClick: (row: any) => onTypeClick(row),
  },
  {
    key: "checklistcategory",
    label: "Checklist Category",
    render: (_: any, row: any) => {
      const catVal = categoryMap ? categoryMap(row) : row?.checklistcategory;
      if (catVal === null || catVal === undefined || catVal === "") return "-";
      const found = categoryOptions.find(
        (opt) => String(opt.value) === String(catVal)
      );
      return found ? found.label : (row?.categoryname || row?.checklistcategorytext || String(catVal) || "-");
    },
  },
  {
    key: "createddate",
    label: "Created On",
    render(value: any) {
      return formatDate(value);
    },
  },
];

export const fields = [
  {
    name: "question",
    label: "Checkpoint",
    placeholder: "Enter Checkpoints",
    required: true,
    type: "textarea" as const,
    rules: validations.checklist.question,
    maxLength: 100,
  },
  {
    name: "isrequired",
    label: "Is Required",
    type: "select" as const,
    required: true,
    options: [
      { label: "Yes", value: "true" },
      { label: "No", value: "false" },
    ],
    rules: validations.checklist.isRequired,
  },
  {
    name: "checklisttype",
    label: "Checklist",
    placeholder: "Select Checklist",
    type: "select" as const,
    options: Checklist_Type_OPTIONS,
    required: true,
    rules: validations.checklist.answerLabels,
    mutipleAllow: false,
  },
];